/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["login{display:block;height:100%}login .auth-page .remember-and-login-row{display:flex}login .auth-page .remember-and-login-row>.remember-me-checkbox{flex:1 1 auto;padding-top:8px}login .auth-page .remember-and-login-row>.login-button{flex:1 1 auto;text-align:right}login .auth-page .info-row{margin:35px 0;text-align:center}login .auth-page .info-row>span{margin-right:5px}login .auth-page .social-icons{text-align:center}"];
export { styles as styles };
